import React, { useEffect, useState } from 'react'
import { ThemeProvider } from '@mui/material'
import { theme } from './styles'
import DrawerNav from './components/DrawerNav/DrawerNav'
import { useSelector, useDispatch } from 'react-redux'

import './app.css'

import { getCompany } from './actions/company'
import { getProperties } from './actions/properties'
import { getCounties } from './actions/counties'
import { getTenantACEntries } from './actions/tenantACEntries'
import { getTenancies } from './actions/tenancies'
import { getAllProperties } from './actions/allProperties'
import { getUnits } from './actions/units'
import { getAllUnits } from './actions/allUnits'
import { getAllTenancies } from './actions/allTenancies'
import { getReceipts } from './actions/receipts'
import { getTenants } from './actions/tenants'
import { getRoles } from './actions/roles'
import { getMaintenanceRequests } from './actions/maintenanceRequests'
import { getIncidents } from './actions/incidents'
import { getExpenses } from './actions/expenses'
import { getNotices } from './actions/notices'
import axios from './api/axios'
import { putSubscription } from './actions/subscription'

const App = () => {
  const loggedIn = useSelector((state) => state.loggedIn)
  const dispatch = useDispatch()
  const [subscription, setSubscription] = useState({})

  // Initialize app data when logged in
  useEffect(() => {
    if (loggedIn) {
      // Batch all initialization calls for better performance
      const initializeAppData = async () => {
        try {
          // Execute all API calls in parallel
          await Promise.all([
            dispatch(getRoles()),
            dispatch(getCompany()),
            dispatch(getCounties()),
            dispatch(getUnits()),
            dispatch(getProperties()),
            dispatch(getTenantACEntries()),
            dispatch(getTenancies()),
            dispatch(getAllTenancies()),
            dispatch(getReceipts()),
            dispatch(getAllUnits()),
            dispatch(getAllProperties()),
            dispatch(getTenants()),
            dispatch(getMaintenanceRequests()),
            dispatch(getIncidents()),
            dispatch(getExpenses()),
            dispatch(getNotices()),
          ])
        } catch (error) {
          console.error('Error initializing app data:', error)
        }
      }

      initializeAppData()
    }
  }, [dispatch, loggedIn])

  // Handle service worker registration
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      const handleServiceWorker = async () => {
        try {
          const register = await navigator.serviceWorker.register('/sw.js')

          const subscription = await register.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey:
              'BIW2rvAEi6SQk_gzpKKXABU1JRfZp3Zenkib_7kzOVZ9_z_-jimzE_jYOG0ufVFJ4Cx_LVkQaUHjj-wy9FAGoFQ',
          })

          const response = await axios.post('/notification/client/subscribe', {
            subscription,
          })

          setSubscription(response.data)
        } catch (error) {
          console.error('Service worker registration failed:', error.message)
        }
      }

      handleServiceWorker()
    }
  }, [])

  // Update subscription when it changes
  useEffect(() => {
    if (subscription.id) {
      dispatch(putSubscription(subscription))
    }
  }, [subscription, dispatch])

  return (
    <ThemeProvider theme={theme}>
      <DrawerNav />
    </ThemeProvider>
  )
}

export default App
